import { Button, Checkbox, Form, Input, Radio, Space, Switch } from "antd";

import DownArrowIcon from "../../assets/icons/DownArrowIcon";
import digigo_logo from "../../assets/images/digiGO logo.svg";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function ManagePackage({
  handleClose,
  data,
  type,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {};

  return (
    <CustomModal
      //   title=""
      title={
        <div className="flex gap-x-2.5">
          Add New Package{" "}
          <div className="cursor-pointer px-2 py-1 rounded-[100px] bg-[#BFC4D3] w-[100px] flex justify-center items-center">
            <div className="text-white text-sm font-semibold tracking-tight px-3 py-1 bg-[#001652] rounded-[100px] border-2 border-[#BFC4D3]/25 justify-center items-center gap-2.5 inline-flex">
              digiGO
              <DownArrowIcon />
            </div>
          </div>
        </div>
      }
      {...rest}
      handleClose={handleClose}
      width={600}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <>
          <div className="flex gap-x-2.5 items-center justify-between">
            <Form.Item
              name=""
              label="#1"
              className="mb-4 w-full"
              rules={[
                {
                  required: true,
                  message: "Please enter a package name",
                },
              ]}
            >
              <Input size="large" placeholder="Package 1" />
            </Form.Item>

            <p className="flex items-center gap-x-1 ">
              <Switch /> <span>Active</span>
            </p>
          </div>

          <div className="flex items-center gap-6">
            <p className="text-[#2d3643] text-base font-medium  leading-7">
              Subscription Type:
            </p>
            <Form.Item name="target_type" initialValue="all" className="mb-0 ">
              <Radio.Group className="custom-radio !h-auto" size="large">
                {targetTypes?.map((el) => (
                  <Radio
                    className="text-header text-sm font-medium mr-3.5"
                    value={el?.value}
                    key={el?.value}
                  >
                    {el.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </div>

          <div className="grid grid-cols-2 gap-2.5">
            <Form.Item
              name=""
              label="Price Set"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter Price",
                },
              ]}
            >
              <Input size="large" placeholder="0.00" prefix="BDT" />
            </Form.Item>
            <Form.Item
              name=""
              label="User Qty"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter qty",
                },
              ]}
            >
              <Input size="large" placeholder="00" />
            </Form.Item>
          </div>

          <div className="flex justify-between items-center gap-2.5">
            <Form.Item
              name="file"
              label="Price Set"
              className="mb-4 w-full"
              rules={[
                {
                  required: true,
                  message: "Please enter Price",
                },
              ]}
            >
              <Input size="large" placeholder="0.00" prefix="BDT" />
            </Form.Item>

            <img src={digigo_logo} alt="" className="w-[134px] h-[54px]" />
          </div>

          <div className="w-full px-3 py-1.5 bg-[#f0f3f8] rounded-md justify-between items-center flex">
            <div className="justify-start items-center gap-4 flex">
              <div className="text-display-body text-lg font-semibold leading-[30px]">
                Package’s Features
              </div>

              <Form.Item className="mb-0">
                <Checkbox>
                  {" "}
                  <p className="text-[#4a71ff] text-sm font-medium leading-normal">
                    Select All
                  </p>
                </Checkbox>
              </Form.Item>
            </div>
            <div className="text-[#fe7235] text-sm font-medium leading-normal">
              Unselect
            </div>
          </div>

          <Space className="w-full mt-2" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
            >
              {type === "UPDATE" ? "Update" : "Save"}
            </Button>
          </Space>
        </>
      </Form>
    </CustomModal>
  );
}

export const targetTypes = [
  { label: "Free", value: "free" },
  { label: "Monthly", value: "monthly" },
  { label: "Yearly", value: "yearly" },
];
